import { Box, Fab } from "@mui/material"
import { useRecoilValue, useSetRecoilState } from "recoil"
import { linksState, linksRequestNumberState } from "../atoms/portale"
import HomeSegment from "./HomeSegment"
import { PreferredCard } from "./PreferredCard"
import AddIcon from '@mui/icons-material/Add'
import React from "react"
import { useEditPreferito } from "../atoms/preferito"
import { Preferito } from "../models/ServiceDescriptor"
import apiService from "../services/api"
// import logConstants from "../utils/logConstants"

export const LinkSegment = () => {
    const links = useRecoilValue(linksState)
    const setLinksRequestNumberState = useSetRecoilState(linksRequestNumberState)
    const editPreferito = useEditPreferito()

    const handleAddLink = (ev: React.MouseEvent<HTMLButtonElement>) => {
        ev.preventDefault()
        ev.stopPropagation()
        
        editPreferito(undefined, undefined, undefined, undefined, 'Edit link siti esterni')
    }
    const handleMove = (newpref?: Preferito[]) => {
        // console.log(`%cPreferitiSegment:handleMove: %o`, logConstants.blue10ptBold, newpref)
        if (newpref) {
            apiService.savePrefOrder(newpref.map(v => v.id))
                .then(() => setLinksRequestNumberState(current => current + 1))
        }
    }

    // console.log({links});
    return (
        <HomeSegment title='Link' nrec={links?.length}>
            <Box sx={{
                position: 'relative',
                display: 'flex',
                flexWrap: 'wrap',
                mt: 2,
                px: 0.5,
                gap: 1,
                minHeight: 26,
            }}>
                <Fab size="small" color="primary" sx={{ position: 'absolute', top: -8, right: 8}} onClick={handleAddLink}><AddIcon /></Fab>
                {links && links.map(link => <PreferredCard key={link.id} item={link} preferiti={links} onMove={handleMove} />)}
            </Box>
        </HomeSegment>
    )
}
